const PROMO_UPDATE = 'promo/UPDATE';
const GET_PROMO = 'promo/GET';
const GET_REDEEMS = 'promo/REDEEMS';

export {
  PROMO_UPDATE,
  GET_PROMO,
  GET_REDEEMS
}